import axios from 'axios';
import * as actionsType from './types';
import { confirmAction } from '../ui/feedback';

// Yes/no confirmation used across the app. Same contract as before (callback runs on "כן");
// the dialog itself now comes from the new UI kit (ui/feedback.js).
export const withConfirmAlert = (callback,text) => async dispatch => {
  confirmAction({ text, onYes: callback });
}
export const fetchUser = () => async dispatch => {
  const res = await axios.get('/api/current_user');
  if(res.data !== ""&&res.data !== "err"&&res.data !== "conError"){
    dispatch({type: actionsType.SET_SHOW_LOGIN,show: false});
  }
  dispatch({type: actionsType.FETCH_USER,user: res.data });
}

export const addItemToList = (listName,item) => async dispatch => {
  const res = await axios.post('/api/addItemToList',{listName:listName,item:item});
  return res.data;
}
export const deleteFromList = (id,tableName) => async dispatch => {
  const res = await axios.post('/api/deleteFromList',{id:id,tableName:tableName});
  return res.data;
}
export const logIn = (password,username) => async dispatch => {
  const res = await axios.post('/api/logIn',{password:password,username:username});
  if(res.data !== 'err'){
    dispatch({type: actionsType.FETCH_USER,user: res.data });
  }
  else
    return res.data;
}

export const getDISTINCTListFromDB = (returns,filters,DBname,postFix) => async dispatch => {
  const res = await axios.post('/api/getDISTINCTListFromDB',{returns:returns,filters:filters,DBname:DBname,postFix:postFix});
  return res.data;
}

export const getListFromDB = (returns,filters,DBname) => async dispatch => {
  const res = await axios.post('/api/getListFromDB',{returns:returns,filters:filters,DBname:DBname});
  return res.data;
}

export const updateListItemLocation = (id,location) => async dispatch => {
  const res = await axios.post('/api/updateListItemLocation',{id,location});
  return res.data;
}
//-----------alert
export const showAlert = (text) => async dispatch => {
  dispatch({type: actionsType.SET_SHOW_ALERT, show: true ,text: text});
  setTimeout(() => {
    dispatch({type: actionsType.SET_SHOW_ALERT, show: false ,text: ''});
  },4000);
}